export const EVENTS = {
    BLOCKED: 'advertisement.blocked',
    SELECTED: 'advertisement.selected',
    FAILED: 'advertisement.failed',
    PRESENTED: 'advertisement.presented',
    SUCCEEDED: 'advertisement.succeeded'
};

export const emitEdapEvent = (event, options = {}) => {
    window.edap = window.edap || [];
    window.edap.push((edap) => edap.trigger(event, options));
};
